import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=781bd116"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AContainer: require('/codebuild/output/src3924949784/src/app/components/atoms/Container/AContainer.vue').default,ASnackbar: require('/codebuild/output/src3924949784/src/app/components/atoms/ASnackbar.vue').default})
